


import { Component, Vue } from "vue-property-decorator";

import { CustomNotification } from "@Internal/Models";

import { Roles } from "App";
import { $t, EventBus } from "App/IOC";

import { Activated, Identifiable, Named } from "App/Contracts";

import PopupWindow from "Web/Components/Popup/Window.vue";
import PrivilegeGrid from "./PrivilegeGrid.vue";

/* Flat, fully-reactive privilege holder (every key is a own property so Vue tracks toggles). */
function NewModel() {
    return {
        Name: "",
        Description: "",
        PlanRead: false,
        PlanUpdate: false,
        CouponRead: false,
        CouponCreate: false,
        CustomerRead: false,
        CustomerCreate: false,
        AdsPublicationRead: false,
        AdsPublicationCreate: false
    };
}

@Component({
    components: {
        PopupWindow,
        PrivilegeGrid
    }
})
export default class RoleForm extends Vue {
    private model = NewModel();

    private createAction: Identifiable & Named & Activated = {
        Id: "create",
        Name: $t( "ROLES_confirmCreate" ),
        Active: false
    };

    private get canCreate(): boolean {
        return this.model.Name.trim() !== "";
    }

    private refreshAction(): void {
        this.createAction.Active = this.canCreate;
    }

    private async create(): Promise<void> {
        if( !this.canCreate )
            return;

        this.createAction.Active = false;

        const [ created, error ] = await Roles.Create( this.model as any );

        if( error !== undefined || created === undefined ) {
            EventBus.Publish( "Error", error );
            this.refreshAction();
            return;
        }

        EventBus.Publish(
            "Notification",
            CustomNotification.Success(
                $t( "ROLES_createSuccessTitle" ),
                $t( "ROLES_createSuccessMessage" )
            )
        );

        this.$emit( "Create", created );
        this.$emit( "Close" );
    }
}
